
import { MediaMobile, MediaTablet } from 'api/const/MediaQuery';
import clsx from 'clsx';
import { Service } from 'components/pagine';
import useMediaQuery from 'hook/useMediaQuery';
import React, { FC, useContext, useMemo, useState } from 'react'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import './ServiceTable.css'
import { formatTitle } from 'shared/utils/formatFunction';
import { Button, Logo, TimedTooltip } from 'components/atoms';
import { Link } from 'react-router-dom';

interface iServicesTableBody {
  data: Service[];
  askForaMatch: (serviceId: string) => void
  selectedId?: string
  setSelectedId?: (selectedId: string) => void
  isLoading:boolean
  setIsLoading:(par:boolean)=> void
}


export const ServicesTableBody = ({ data, askForaMatch, selectedId, setSelectedId , isLoading, setIsLoading}: iServicesTableBody) => {

  const { baseUri } = useContext(AppGeneralContext)
  const [tooltipIsOpen, setTooltipIsOpen] = useState<boolean>(false)
  const tablet = useMediaQuery(MediaTablet)
  const mobile = useMediaQuery(MediaMobile)
  

  const Match = (id: string) => {
    window.scrollTo(0, 0);
    askForaMatch(id);
    setIsLoading(true)
  }




  const showBody = useMemo(() => {

    if (mobile) {
      return (
        data.map((el, index) => {
          let disabled = false
          return (
            <div key={el.id} className='d-flex tab-row flex-column'>
              <div className='d-flex  pb-3 pt-3  justify-content-between align-items-start' id={el.id}>
                <div className=" ps-2 d-flex col-3 ">
                  <img src={el.logoUrl && el.logoUrl !== "" ? baseUri + el.logoUrl : "/logo192.png"} alt={el.title} className="logo_service" />
                </div>
                <div className=" ps-4 pe-2 d-flex flex-column col-8  align-items-start">
                  <div className='d-flex flex-column   '>
                    <div className=" fw-bold text-uppercase">{el.title}</div>
                    <div className="  pb-2 text-wrap text-break text-truncate ">{formatTitle(el.shortDescription, 60)}</div>
                  </div>
                  <div className='d-flex flex-column align-items-end  w-100'>
                  {el.isMatched?
                    <TimedTooltip
                      text={"Match already sent"}
                      childeren={
                        <Button background={'var(--primary)'}
                          text='MATCH FOR FREE' className={clsx('d-flex flex-row text-white justify-content-between')}
                          border={true}
                          borderColor='var(--primary)'
                          icon={
                            < Logo colorLogo='white' className='w-25 pe-2' />
                          }
                          primary
                          disabled={el?.isMatched || isLoading || disabled}
                      onClick={() => { Match(el?.id ?? "") ; disabled = true}} />
                      } /> :
                    <Button background={'var(--primary)'}
                      text='MATCH FOR FREE' className={clsx('d-flex flex-row text-white justify-content-between')}
                      border={true}
                      borderColor='var(--primary)'
                      icon={
                        < Logo colorLogo='white' className='w-25 pe-2' />
                      }
                      primary
                      disabled={el?.isMatched || isLoading || disabled}
                      onClick={() => { Match(el?.id ?? "") ; disabled = true}} />
                    }
                    <Link to={`/start-up/profile/services/${el.id}/${false}`} className='link pt-1 text-center text-dark fw-normal w-100 ps-4 '>More Info</Link>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      )
    } else {
      return (
        data.map((el, index) => {
          let disabled = false
          return (
            <div key={el.id} className='d-flex tab-row flex-column'>
              <div className='d-flex  pb-3 pt-3  justify-content-between align-items-center' id={el.id}>
             
                <div className="col-1 ps-2">
                  <img src={el.logoUrl && el.logoUrl !== "" ? baseUri + el.logoUrl : "/logo192.png"} alt={el.title} className=" logo_service" />
                </div>
                <div className='d-flex flex-column col-7 ps-4 pe-2 '>
                  <div className=" fw-bold text-uppercase">{el.title}</div>
                  <div className=" text-wrap text-break">{formatTitle(el.shortDescription, 60)}</div>
                </div>
                <div className="col-4 actions text-end d-flex flex-column  align-items-center">
                  {el.isMatched?
                    <TimedTooltip
                      text={"Match already sent"}
                      childeren={
                        <Button background={'var(--primary)'}
                          text='MATCH FOR FREE' className={clsx('d-flex flex-row text-white justify-content-between')}
                          border={true}
                          borderColor='var(--primary)'
                          icon={
                            < Logo colorLogo='white' className='w-25 pe-2' />
                          }
                          primary
                          disabled={el?.isMatched || isLoading || disabled}
                      onClick={() => { Match(el?.id ?? "") ; disabled = true}} />
                      } /> :
                    <Button background={'var(--primary)'}
                      text='MATCH FOR FREE' className={clsx('d-flex flex-row text-white justify-content-between')}
                      border={true}
                      borderColor='var(--primary)'
                      icon={
                        < Logo colorLogo='white' className='w-25 pe-2' />
                      }
                      primary
                      disabled={el?.isMatched || isLoading || disabled}
                      onClick={() => { Match(el?.id ?? "") ; disabled = true}} />
                    }

                  <Link to={`/start-up/profile/services/${el.id}/${false}`} className='link pt-1 text-dark fw-normal'>More Info</Link>
                </div>
              </div>
            </div>
          )
        })
      )
    }
  }, [selectedId, tooltipIsOpen, tablet, mobile, data, isLoading])

  return (
    <>
      {showBody}
    </>
  )
}
